import React from 'react';
import { Link } from 'react-router-dom';
import { HeartFilled } from '@ant-design/icons';

const Footer = () => (
  <>
    <style>{`
      .pub-footer {
        background: #001529;
        color: rgba(255,255,255,0.65);
        padding: 56px 32px 28px;
        font-family: 'Inter', -apple-system, sans-serif;
      }
      .pub-footer-inner {
        max-width: 1200px; margin: 0 auto;
      }
      .pub-footer-grid {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr;
        gap: 40px;
        padding-bottom: 40px;
        border-bottom: 1px solid rgba(255,255,255,0.08);
      }
      .pub-footer-brand-icon {
        width: 42px; height: 42px; border-radius: 10px;
        background: #1890ff;
        display: flex; align-items: center; justify-content: center;
        margin-bottom: 14px;
      }
      .pub-footer-brand-name {
        font-size: 18px; font-weight: 800; color: #fff;
        margin-bottom: 10px; letter-spacing: -0.3px;
      }
      .pub-footer-brand-desc {
        font-size: 13px; line-height: 1.7;
        color: rgba(255,255,255,0.5);
        max-width: 240px;
      }
      .pub-footer-col h4 {
        color: #fff; font-size: 13px; font-weight: 700;
        letter-spacing: 0.6px; text-transform: uppercase;
        margin-bottom: 16px;
      }
      .pub-footer-col ul {
        list-style: none; margin: 0; padding: 0;
        display: flex; flex-direction: column; gap: 9px;
      }
      .pub-footer-col ul li a {
        color: rgba(255,255,255,0.55); font-size: 13.5px;
        text-decoration: none; transition: color .18s;
      }
      .pub-footer-col ul li a:hover { color: #1890ff; }
      .pub-footer-bottom {
        display: flex; align-items: center; justify-content: space-between;
        padding-top: 24px; flex-wrap: wrap; gap: 8px;
      }
      .pub-footer-copy { font-size: 12.5px; color: rgba(255,255,255,0.35); }
      .pub-footer-made {
        font-size: 12.5px; color: rgba(255,255,255,0.35);
        display: flex; align-items: center; gap: 5px;
      }
      @media (max-width: 768px) {
        .pub-footer-grid { grid-template-columns: 1fr 1fr; gap: 28px; }
      }
      @media (max-width: 480px) {
        .pub-footer-grid { grid-template-columns: 1fr; }
      }
    `}</style>

    <footer className="pub-footer">
      <div className="pub-footer-inner">
        <div className="pub-footer-grid">

          {/* Brand */}
          <div>
            <div className="pub-footer-brand-icon">
              <HeartFilled style={{ color: '#fff', fontSize: 20 }} />
            </div>
            <div className="pub-footer-brand-name">Wellness</div>
            <p className="pub-footer-brand-desc">
              The all-in-one biometric wellness management platform.
              Automate attendance, track health, and grow your center.
            </p>
          </div>

          {/* Product */}
          <div className="pub-footer-col">
            <h4>Product</h4>
            <ul>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/login">Admin Login</Link></li>
            </ul>
          </div>

          {/* Features */}
          <div className="pub-footer-col">
            <h4>Features</h4>
            <ul>
              <li><Link to="/features#biometric">Biometric Check-in</Link></li>
              <li><Link to="/features#attendance">Attendance Tracking</Link></li>
              <li><Link to="/features#payments">Payments</Link></li>
              <li><Link to="/features#health">Health Records</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="pub-footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:support@fingerwellness.in">timesmanymanas@gmail.com</a></li>
              <li><a href="tel:+919999999999">+91 9301021020</a></li>
              <li><a href="#location">India</a></li>
            </ul>
          </div>

        </div>

        <div className="pub-footer-bottom">
          <span className="pub-footer-copy">
            © {new Date().getFullYear()} Wellness. All rights reserved.
          </span>
          <span className="pub-footer-made">
            Made with <HeartFilled style={{ color: '#ff4d4f', fontSize: 12 }} /> in India
          </span>
        </div>
      </div>
    </footer>
  </>
);

export default Footer;
